import { styled, Box } from '@mui/material';

export const StyledCardContainer = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;
